import { Button } from '@/shared/components/ui/button/Button';
import type { AssignmentAbilities } from './productDocumentsView.types';

interface Props extends AssignmentAbilities {
  label: string;
  onChange: () => void;
  onUnassign: () => void;
}

export function AssignmentActions({ label, canEdit, canDelete, onChange, onUnassign }: Props) {
  return (
    <div className="flex justify-end gap-2">
      {canEdit && (
        <Button type="button" size="sm" variant="neutral" appearance="outline" ariaLabel={`Change ${label}`} onClick={onChange}>
          Change
        </Button>
      )}
      {canDelete && (
        <Button type="button" size="sm" variant="danger" appearance="ghost" ariaLabel={`Unassign ${label}`} onClick={onUnassign}>
          Unassign
        </Button>
      )}
    </div>
  );
}
